// extracted by mini-css-extract-plugin
module.exports = {"popupContainer":"shape-stroke-style-picker_popupContainer__EiICu"};